import React from 'react';
import { Box, Typography } from '@mui/material';
import UserListModaledit from './UserListModaledit';

const UserListtable = ({ number, item, render, setRender }) => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          background: '#fff',
          color: '#fff',
          height: '45px',
          width: '1300px',
        }}
      >
        <Typography
          sx={{
            width: '70px',
            display: 'flex',
            color: '#000',
            alignItems: 'center',
            justifyContent: 'center',
            borderLeft: '1px solid #e0e0ef',
            borderTop: '1px solid #e0e0ef',
            borderBottom: '1px solid #e0e0ef',
            height: 44,
            background: '#fff',
            fontSize: 12,
          }}
        >
          {number + 1}
        </Typography>
        <Typography
          sx={{
            width: '500px',
            borderLeft: '1px solid #e0e0ef',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderBottom: '1px solid #e0e0ef',
            borderTop: '1px solid #e0e0ef',
            // paddingLeft: 3,
            height: 44,
            color: '#000',
            background: '#fff',
            fontSize: 12,
          }}
        >
          {item.name}
        </Typography>
        <Typography
          sx={{
            width: '500px',
            borderLeft: '1px solid #e0e0ef',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderBottom: '1px solid #e0e0ef',
            borderTop: '1px solid #e0e0ef',
            // paddingLeft: 3,
            height: 44,
            color: '#000',
            background: '#fff',
            fontSize: 12,
          }}
        >
          {item.email}
        </Typography>
        <Typography
          sx={{
            width: '500px',
            borderLeft: '1px solid #e0e0ef',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderBottom: '1px solid #e0e0ef',
            borderTop: '1px solid #e0e0ef',
            paddingLeft: 3,
            height: 44,
            color: '#000',
            background: '#fff',
            fontSize: 12,
          }}
        >
          {item.university}
        </Typography>
        <Typography
          sx={{
            width: '180px',
            borderLeft: '1px solid #e0e0ef',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderBottom: '1px solid #e0e0ef',
            borderTop: '1px solid #e0e0ef',
            // paddingLeft: 3,
            height: 44,
            color: '#000',
            background: '#fff',
            fontSize: 12,
          }}
        >
          {item.role}
        </Typography>
        <Typography
          sx={{
            width: '130px',
            borderLeft: '1px solid #e0e0ef',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderBottom: '1px solid #e0e0ef',
            borderTop: '1px solid #e0e0ef',
            // paddingLeft: 3,
            height: 44,
            color: '#000',
            background: '#fff',
            fontSize: 12,
          }}
        >
          {item.year}
        </Typography>
        {/* <Typography
          sx={{
            width: "200px",
            borderLeft: "1px solid #e0e0ef",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderBottom: "1px solid #e0e0ef",
            borderTop: "1px solid #e0e0ef",
            paddingLeft: 3,
            height: 44,
            color: "#fff",
            background: "#004A99",
          }}
        >
          ရက်စွဲ 
        </Typography> */}
        <Typography
          sx={{
            width: '150px',
            display: 'flex',
            alignItems: 'center',
            borderLeft: '1px solid #e0e0ef',
            borderRight: '1px solid #e0e0ef',
            borderBottom: '1px solid #e0e0ef',
            borderTop: '1px solid #e0e0ef',
            // paddingLeft: 3,
            color: '#000',
            background: '#fff',
            height: 44,
            justifyContent: 'center',
            fontSize: 12,
          }}
        >
          <UserListModaledit
            item={item}
            render={render}
            setRender={setRender}
          />
        </Typography>
      </Box>
    </>
  );
};

export default UserListtable;
